const BASE = process.env.REACT_APP_API_URL || '/api';

async function jsonOrThrow(res) {
  const txt = await res.text();
  let body;
  try { body = txt ? JSON.parse(txt) : null; } catch { body = { error: txt }; }
  if (!res.ok) {
    const e = new Error(body?.error || `HTTP ${res.status}`);
    e.status = res.status;
    e.body = body;
    throw e;
  }
  return body;
}

export const api = {
  status: () => fetch(`${BASE}/status`).then(jsonOrThrow),
  sensors: () => fetch(`${BASE}/sensors`).then(jsonOrThrow),
  sensor: (ident) => fetch(`${BASE}/sensor/${ident}`).then(jsonOrThrow),
  history: (ident, intervalo = 1) =>
    fetch(`${BASE}/sensor/${ident}/history?intervalo=${intervalo}`).then(jsonOrThrow),

  // Nuevas funciones para las anotaciones SQL
  getAnnotations: async () => {
    const res = await fetch('/api/anotaciones');
    return res.json();
  },
  
  saveAnnotation: async (annotationData) => {
    try {
      const res = await fetch('/api/anotaciones', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(annotationData)
      });
      
      // Si el servidor ha devuelto un error 500, lanzamos el error
      if (!res.ok) {
        throw new Error(`Error en el servidor: ${res.status}`);
      }

      return await res.json();
    } catch (error) {
      console.error("Fallo al guardar la anotación:", error);
      alert("Error de conexión con el backend al guardar.");
      return null;
    }
  },
  
  deleteAnnotation: async (id) => {
    const res = await fetch(`/api/anotaciones/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  }
};